import { createFileRoute } from '@tanstack/react-router'

import { ConfirmacaoPorClique } from '@/components/gestor/recuperacao/ConfirmacaoPorClique'

function CancelarIndicacao() {
  return (
    <ConfirmacaoPorClique
      confirmacao="indicacao-cancelada"
      id="titulo-cancelar-indicacao"
      titulo="Cancelar a indicação"
      texto="Um administrador indicou outro e-mail para receber o link de senha deste acesso. Se não foi pedido por você, cancele: nenhum link vai sair para o endereço indicado."
      botao="Cancelar a indicação"
      sucesso="Indicação cancelada. Nenhum link de senha vai sair para o e-mail indicado."
    />
  )
}

/*
 * `/gestor/indicacao/cancelar#t=…`: tela pública aberta pelo link do aviso que
 * a caixa de login recebe. Abrir não cancela nada; o botão cancela.
 */
export const Route = createFileRoute('/gestor/indicacao/cancelar')({
  component: CancelarIndicacao,
})
